var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{attrs:{"items":_vm.bcItems,"divider":"-"}},[(_vm.getBcChange)?_c('div',[_vm._v(_vm._s(_vm.readItems()))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }